import { Component } from "@angular/core";
import { WindowProvider } from "@app/shared/services/window-provider.service";

@Component({
    selector: "app-mobile-reload",
    templateUrl: "./mobile-reload.component.html",
    styleUrls: ["./mobile-reload.component.scss"],
})
export class MobileReloadComponent {
    constructor(private readonly windowProvider: WindowProvider) {}

    reload() {
        this.windowProvider.getWindow().location.reload();
    }
}
